import * as React from "react";
function SvgSecurity(props, svgRef) {
    return (
        <svg
            width="1em"
            height="1em"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={svgRef}
            {...props}
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M13.033 1.823a2 2 0 00-2.066 0l-6.483 3.91L4 6.025V11.867c0 3.564 1.973 6.188 3.83 7.867a16.762 16.762 0 003.41 2.373 10.075 10.075 0 00.317.157l.02.01.007.003h.002l.001.001.413-.91-.412.91.412.187.412-.187-.412-.91.413.91.003-.001.007-.003.02-.01a10.075 10.075 0 00.317-.157 16.76 16.76 0 003.41-2.373c1.857-1.68 3.83-4.303 3.83-7.867V6.025l-.483-.292-6.484-3.91zm-.456 18.094c-.224.135-.42.245-.577.33a14.762 14.762 0 01-2.83-1.996C7.528 16.763 6 14.637 6 11.867V7.154l6-3.619 6 3.62v4.712c0 2.77-1.527 4.896-3.17 6.384a14.764 14.764 0 01-2.253 1.666zm3.13-8.843l.707-.707L15 8.953l-.707.707-2.793 2.793-1.293-1.293-.707-.707-1.414 1.414.707.707 2 2 .707.707.707-.707 3.5-3.5z"
                fill="currentcolor"
            />
        </svg>
    );
}
const ForwardRef = React.forwardRef(SvgSecurity);
export default ForwardRef;
